import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

export default function ParticipateInfo({ feature }) {
  const { properties } = feature;
  return properties ? (
    <>
      <Typography variant="h5">{properties.Name}</Typography>
      <Typography variant="body2">
        <strong>Category:</strong> {properties.Category}
      </Typography>
      <Typography variant="body2">
        <strong>Place:</strong> {properties.PlaceCategory}
      </Typography>
      <Typography variant="body2" gutterBottom>
        <strong>Status:</strong> {properties.Status}
      </Typography>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => window.open(properties.Website, "_blank")}
      >
        More info
      </Button>
    </>
  ) : null;
}
